const reviews = [
  {
    name: 'Marie L.',
    city: 'Montpellier',
    date: 'Il y a 3 semaines',
    rating: 5,
    text: 'Ma baie coulissante était complètement bloquée, impossible de l\'ouvrir. Le technicien est venu le lendemain matin, a changé les roulettes et réglé le rail en moins d\'une heure. Travail impeccable, baie comme neuve ! Je recommande vivement.',
    initials: 'ML',
  },
  {
    name: 'Jean-Pierre D.',
    city: 'Béziers',
    date: 'Il y a 1 mois',
    rating: 5,
    text: 'Volet roulant électrique en panne depuis des semaines. Devis clair, intervention rapide, moteur remplacé. Tout fonctionne parfaitement. En plus le technicien m\'a expliqué l\'entretien à faire. Très professionnel.',
    initials: 'JD',
  },
  {
    name: 'Sophie M.',
    city: 'Sète',
    date: 'Il y a 2 semaines',
    rating: 5,
    text: 'Vitre fissurée sur ma baie vitrée après un choc. Intervention en 48h, double vitrage remplacé avec un verre identique à l\'origine. On ne voit même pas la différence. Service impeccable du début à la fin.',
    initials: 'SM',
  },
  {
    name: 'Philippe R.',
    city: 'Castelnau-le-Lez',
    date: 'Il y a 3 semaines',
    rating: 5,
    text: 'Store banne qui ne se repliait plus. Diagnostic précis, bras articulé changé, toile nettoyée. Le store fonctionne mieux qu\'avant ! Prix raisonnable et travail soigné. Merci à toute l\'équipe.',
    initials: 'PR',
  },
  {
    name: 'Christine V.',
    city: 'Lattes',
    date: 'Il y a 1 mois',
    rating: 5,
    text: 'Excellent service ! Crémone de fenêtre cassée, le technicien avait la pièce dans son camion. Réparé en 30 minutes chrono. Ponctuel, courtois, efficace. C\'est rare de nos jours, bravo !',
    initials: 'CV',
  },
  {
    name: 'Laurent B.',
    city: 'Agde',
    date: 'Il y a 2 mois',
    rating: 5,
    text: 'Roulettes de baie coulissante complètement usées, la baie pesait une tonne. Remplacement des 4 galets en 1h, réglage parfait. La baie glisse toute seule maintenant. 10 ans de garantie en plus, que demander de plus ?',
    initials: 'LB',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <span className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} className="w-4 h-4 flex items-center justify-center">
          <i className={`${star <= rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-300'} text-sm`}></i>
        </span>
      ))}
    </span>
  );
}

export default function ReviewsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* En-tête */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Ce que nos clients disent de nous
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg max-w-xl mx-auto">
            La satisfaction de nos clients dans l'Hérault est notre meilleure récompense.
          </p>
        </div>

        {/* Badge note globale */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 mb-10">
          <div className="flex items-center gap-2">
            <StarRating rating={5} />
            <span className="font-heading font-bold text-lg text-primary-500">4.9/5</span>
          </div>
          <span className="hidden sm:block w-1 h-1 rounded-full bg-background-300"></span>
          <span className="text-secondary-500 text-sm font-body">
            Basé sur <strong className="text-primary-500 font-semibold">147 avis</strong> vérifiés
          </span>
        </div>

        {/* Grille d'avis */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="bg-white rounded-lg p-6 flex flex-col gap-4 border border-background-200"
            >
              {/* En-tête de l'avis */}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  {/* Avatar avec initiales */}
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 font-heading font-bold text-sm shrink-0">
                    {review.initials}
                  </span>
                  <div>
                    <p className="font-heading font-semibold text-sm text-primary-500">
                      {review.name}
                    </p>
                    <p className="text-secondary-500 text-xs font-body">
                      {review.city}
                    </p>
                  </div>
                </div>
                <StarRating rating={review.rating} />
              </div>

              {/* Texte de l'avis */}
              <p className="text-secondary-500 text-sm font-body leading-relaxed flex-1">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Date */}
              <p className="text-background-400 text-xs font-body">
                {review.date}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}